export const nftsBaseUrl = '/gens'
export const yourBaseUrl = '/gens/yours'
